/**
 * Converts a lits of strings to react-select options.
 */
export function stringsToSelectOptions(strings: string[]) {
  return strings.map((str) => ({
    label: str,
    value: str,
  }));
}
